export const headerHeight = 52;
export const cellHeight = 44;

export const columnNames = {
  text: 'Text',
  number: 'Number',
  floatNumber: 'Float',
  boolean: 'Boolean',
  date: 'Date',
  reference: 'Reference',
  dropdown: 'Reference',
};
